const DefaultTheme = {
    images : {
        loginLogo: "/img/farm-logo.svg",
        whiteLogo: "/img/fc-logo-white.svg",
        favicon: "/img/favicon.ico",
        leftMenuLogo: "/img/farmcontrol_logo_only.svg",
        headerLogo: "/img/name-only.png.svg",

        touchIconIphone: "/img/touch-icon-iphone.png",
        touchIconIpad:"/img/touch-icon-ipad.png",
        touchIconIphoneRetina: "/img/touch-icon-iphone-retina.png",
        touchIconIpadRetina: "/img/touch-icon-ipad-retina.png",
        appleTouchStartupImage: "/img/apple-touch-startup-image"
    },
    css: [
        "/themes/default.css"
    ],
    strings: {
        title: "Farmcontrol - Product Monitorization"
    }
}

export default DefaultTheme;